import i18next from "i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import enData from "./locales/en.json";
import arData from "./locales/ar.json";
import mobileArabic from "./locales/mobile-funnel-ar.json";
import { languageFromPath } from "./utils/storefrontLocale.mjs";
import { STORAGE_KEYS } from "./utils/getUserConfig";
import { DEFAULT_VALUES } from "./utils/getUserConfig";
import { track } from "./utils/track";

export const resources = {
  en: { translation: enData, mobileFunnel: Object.fromEntries(Object.keys(mobileArabic).map(key => [key, key])) },
  ar: { translation: arData, mobileFunnel: mobileArabic },
};

i18next
  .use(I18nextBrowserLanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: languageFromPath(window.location.pathname),
    fallbackLng: DEFAULT_VALUES.language,
    debug: true,
    interpolation: { escapeValue: false },
    supportedLngs: ["en", "ar"],
    nonExplicitSupportedLngs: true,
    load: "languageOnly",
    // detection: {
    //   order: ["localStorage", "cookie", "navigator"],

    //   lookupLocalStorage: STORAGE_KEYS.LANGUAGE,
    //   lookupCookie: "i18next",

    //   caches: ["localStorage", "cookie"],
    //   cookieDomain: window.location.hostname,
    // },
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: STORAGE_KEYS.LANGUAGE,
      caches: ["localStorage"],
    },
  });

i18next.on("languageChanged", (lng) => {
  localStorage.setItem(STORAGE_KEYS.LANGUAGE, lng);
  document.documentElement.lang = lng;
  track("language_switch", { language: lng });
});

const savedLang = languageFromPath(window.location.pathname);

localStorage.setItem(STORAGE_KEYS.LANGUAGE, savedLang);
document.documentElement.lang = savedLang;

export default i18next;
